import moment from 'moment-timezone';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

const FixedEndWarning = ({ expireMonth, validity }) => (
  <Box display="block" fontStyle="italic">
    <AdditionalInformation
      type="error"
      id="expire-month-notice"
      iconColor="mandarine"
    >
      {s__(
        'Memberships|You are buying a membership with a fixed end month of %{expireMonth}. Therefore the expiration date of your subscription will be %{validity}',
      ).i__({ expireMonth, validity: moment(validity).format('L') })}
    </AdditionalInformation>
  </Box>
);

export default FixedEndWarning;
